<template>
  <div class="exercise">
    <NavigationBar fixed="fixed" :theme="theme" :color="color"></NavigationBar>
    <slot></slot>
  </div>
</template>

<script>

  import NavigationBar from "@/components/bars/NavigationBar";
  export default {
    name: 'Exercise',
    components: {NavigationBar},
    props: ['fixed', 'color', 'theme'],
    data() {
      return {
      }
    },
    methods: {

    },

    created() {
      console.log(`Passed ${this.color} to Exercise`)

    }
  }
</script>

<style>
  .exercise {
    height: 100%;
  }



</style>
